export default __webpack_public_path__ + "static/media/ri_user-line.667491d6.svg";